import { parseTimestamp } from './relativeTime';

export function formatFollowDuration(createdAt: unknown, referenceTime: number | Date = Date.now()): string {
  const followDate = parseTimestamp(createdAt);
  const referenceMilliseconds = referenceTime instanceof Date ? referenceTime.getTime() : referenceTime;
  if (!followDate || !Number.isFinite(referenceMilliseconds)) return 'Time unavailable';

  const elapsedMilliseconds = Math.max(0, referenceMilliseconds - followDate.getTime());
  const elapsedMinutes = Math.floor(elapsedMilliseconds / 60_000);
  if (elapsedMinutes < 1) return 'just now';
  if (elapsedMinutes < 60) return `${elapsedMinutes} ${elapsedMinutes === 1 ? 'minute' : 'minutes'}`;

  const elapsedHours = Math.floor(elapsedMilliseconds / 3_600_000);
  if (elapsedHours < 24) return `${elapsedHours} ${elapsedHours === 1 ? 'hour' : 'hours'}`;

  const elapsedDays = Math.floor(elapsedMilliseconds / 86_400_000);
  if (elapsedDays < 7) return `${elapsedDays} ${elapsedDays === 1 ? 'day' : 'days'}`;
  if (elapsedDays < 30) {
    const weeks = Math.floor(elapsedDays / 7);
    return `${weeks} ${weeks === 1 ? 'week' : 'weeks'}`;
  }
  if (elapsedDays < 365) {
    const months = Math.floor(elapsedDays / 30);
    return `${months} ${months === 1 ? 'month' : 'months'}`;
  }

  const years = Math.floor(elapsedDays / 365);
  return `${years} ${years === 1 ? 'year' : 'years'}`;
}
